const hasBlackListedClass = (node, blackListedClasses) => {
  return blackListedClasses.some((blackListedClass) =>
    node?.classList?.contains(blackListedClass),
  );
};

const findFirstTextNode = (element, blackListedClasses = []) => {
  if (!element) return;
  // Iterate over child nodes of the element
  for (let node of element.childNodes) {
    if (hasBlackListedClass(node, blackListedClasses)) {
      continue;
    }
    // Check if the node is a text node
    if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
      return node; // Return the first non-empty text node
    }
    // If the node is not a text node, recursively search within its children
    if (node.nodeType === Node.ELEMENT_NODE) {
      const textNode = findFirstTextNode(node, blackListedClasses);
      if (textNode) return textNode;
    }
  }
  return null; // Return null if no text node is found
};

export default findFirstTextNode;
